import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const simpleOpeningHoursDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.openingHours,
  componentType: LAYOUT_COMPONENT_TYPE.simpleOpeningHours,
  registryBlockKey: REGISTRY_BLOCK.presentation.simpleOpeningHours,
  displayOrder: 2,
  content: {
    sectionTitle: loc3('Öffnungszeiten', 'Opening hours', 'Giờ mở cửa'),
    hours: loc3(
      'Mo–Fr 09:00–12:00, 14:00–19:00\nSa 09:00–16:00\nSo geschlossen',
      'Mon–Fri 09:00–12:00, 14:00–19:00\nSat 09:00–16:00\nSun closed',
      'Thứ Hai - Thứ Sáu 09:00 - 12:00\n09:00 - 19:00\nThứ Bảy 09:00 - 16:00\nChủ Nhật Đóng cửa',
    ),
    note: loc3(
      'Küche schließt 30 Minuten früher.',
      'Kitchen closes 30 minutes earlier.',
      'Bếp đóng sớm hơn 30 phút.',
    ),
  },
  media: {},
};
